export const frontFAQTypes = {
  GET_FRONT_FAQ: "GET_FRONT_FAQ",
  GET_FRONT_FAQ_TYPE: "GET_FRONT_FAQ_TYPE",
};